import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { AUTH_ENABLED } from '../authConfig';

/**
 * Wave 2 auth seam (DEPLOY-1 → AUTH-4). Wraps <App/> (inside BrowserRouter, see
 * index.js). While REACT_APP_AUTH_ENABLED is off (the default) this is a
 * pass-through: zero behavior change, so it ships to main/prod with the flag off.
 * When on, it mounts Clerk's <ClerkProvider> so the rest of the app can use
 * Clerk components/hooks. See docs/architecture/adr/adr-007-clerk-auth-and-tiers.md.
 */
export default function AuthProvider({ children }) {
    if (!AUTH_ENABLED) {
        return children; // anonymous mode: no auth context
    }

    const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
    if (!publishableKey) {
        throw new Error(
            'REACT_APP_AUTH_ENABLED=true but REACT_APP_CLERK_PUBLISHABLE_KEY is not set. ' +
            'Set the Clerk publishable key or set REACT_APP_AUTH_ENABLED=false.'
        );
    }

    return <ClerkProvider publishableKey={publishableKey}>{children}</ClerkProvider>;
}
